export default __webpack_public_path__ + "static/media/dream.58a4d582.gif";